import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SingleSelect, ButtonSecondary, HorizontalFlex } from 'smartsuite-ui';
import SaveAsModal from './SaveAsModal';
import { useLabelContext } from '../../shared/hooks/labelContext';

export default function SavedDashboardContainer(props) {
    const { dashboardLabels, translationLabels } = useLabelContext();

    const [isSaveAsModalVisible, setIsSaveAsModalVisible] = useState(false);
    const [visibleOverwriteOptions, setVisibleOverwriteOptions] = useState([]);

    useEffect(() => {
        setVisibleOverwriteOptions(
            props.savedDashboardNames.filter(
                (savedDashboardsName) =>
                    savedDashboardsName.key &&
                    savedDashboardsName.key !== 'Default'
            )
        );
    }, [props.savedDashboardNames]);

    const onChange = (selectedValue) => {
        props.loadSavedDashboard(selectedValue.key);
    };

    const onSave = (name, isSaveNew) => {
        setIsSaveAsModalVisible(false);
        props.onSave(name, isSaveNew);
    };

    function getModifiedValue() {
        if (!props.isSavedFilterModified) {
            return props.selectedValue;
        }
        const modifiedOption = props.savedDashboardNames.find(
            (x) => x.name === props.selectedValue.name
        );
        if (!modifiedOption) {
            return props.selectedValue;
        }
        return {
            name: `${modifiedOption.name} ${dashboardLabels.modified}`,
            key: modifiedOption.key,
        };
    }

    return (
        <HorizontalFlex
            cssClassModifiers={['align-flex-start', 'justify-flex-end']}
        >
            <SingleSelect
                options={props.savedDashboardNames}
                valueField="key"
                textField="name"
                onChange={onChange}
                value={getModifiedValue()}
                hasBlankOption={false}
                isClearable={false}
            />
            <ButtonSecondary
                disabled={props.isSaveDisabled}
                onClick={() => setIsSaveAsModalVisible(true)}
            >
                {translationLabels.save}
            </ButtonSecondary>
            <SaveAsModal
                dashboardKey={props.dashboardKey}
                onConfirm={onSave}
                onDismiss={() => setIsSaveAsModalVisible(false)}
                isModalVisible={isSaveAsModalVisible}
                modifiedFrom={props.selectedValue.modifiedFrom}
                pageTitle={props.pageTitle}
                siteMapKey={props.siteMapKey}
                viewKey={props.viewKey}
                visibleOverwriteOptions={visibleOverwriteOptions}
            />
        </HorizontalFlex>
    );
}

SavedDashboardContainer.propTypes = {
    dashboardKey: PropTypes.string.isRequired,
    isSaveDisabled: PropTypes.bool.isRequired,
    isSavedFilterModified: PropTypes.bool.isRequired,
    loadSavedDashboard: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    pageTitle: PropTypes.string.isRequired,
    savedDashboardNames: PropTypes.instanceOf(Array).isRequired,
    selectedValue: PropTypes.instanceOf(Object).isRequired,
    siteMapKey: PropTypes.string,
    viewKey: PropTypes.string.isRequired,
};

SavedDashboardContainer.defaultProps = {
    siteMapKey: undefined,
};
